export const SET_MAP_DATA = 'SET_MAP_DATA';
export const SET_FLOOR_ID = 'SET_FLOOR_ID';
export const SHOW_EX_DETAILS_UID = 'SHOW_EX_DETAILS_UID';
export const CLOSE_EX_MODAL = 'CLOSE_EX_MODAL';

